/* Client-side user notifications
* to trigger anywhere in client use:
* $(document).trigger('notify.ck',{message:"text-or-html-code-here"};
* or
* $(document).trigger('notify.ck',{message:"text-or-html-code-here",severity:"optional-class-added-to-message"});
* current valid severity values: warn
* New messages will appear at the top.
* Message list is cleared on close.
*/
<template>
    <div class="notificationList" v-if="show">
        <ul>
            <li v-for="item in messages.slice().reverse()" v-html="item.message" v-bind:class="[item.severity]"/>
        </ul>
        <div class="closeNotification glyphicon glyphicon-remove" v-on:click="closeNotification"/>

    </div>
</template>

<script>

  export default {
    name: 'Notification',
    created() {
      let _this = this;
      $(document).on('notify.ck', function (event, data) {
        if (typeof data.message == 'string' && data.message.length > 0) {
          _this.messages.push(data);
        }
      });
    },
    data() {
      return {
        messages: []
      };
    },

    computed: {
      show() {
        return (this.messages.length > 0) ? true : false;
      }
    },
    methods: {
      closeNotification() {
        this.messages = [];
      },
    }
  };
</script>

<style>

    .notificationList {
        background-color: #ddd;
        border: 5px solid #777;
        border-radius: 15px;
        margin: 0px 2%;
        min-height: 70px;
        padding: 5px;
        position: fixed;
        top: 95px;
        width: 96%;
        z-index: 99999;
    }

    .notificationList ul {
        list-style: none;
        margin: 0px;
        max-height: 155px;
        overflow: auto;
        padding: 15px 45px;
        padding-inline-start: 0px;
        text-align: center;
        -webkit-padding-start: 0px;
    }

    .notificationList li {
        border-bottom: 1px solid #777;
        padding: 10px 0px;
        text-decoration: italic;
    }

    .notificationList li:last-child {
        border-bottom: none;
    }

    .notificationList li.warn {
        color: red;
    }

    @media only screen and (max-width: 1200px) {
        .notificationList {
            top: 55px;
        }
    }

    .closeNotification {
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 20px;
    }

</style>

